export default __webpack_public_path__ + "static/media/white-spade-img.4f2a733f.webp";